import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { recruitingApi } from '../../../api/recruiting.js';

export default function Requisitions() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState(null);

  function refresh() {
    setLoading(true);
    recruitingApi
      .listRequisitions()
      .then((d) => setItems(d?.items || []))
      .catch((e) => setError(e.response?.data?.message || 'Failed to load'))
      .finally(() => setLoading(false));
  }
  useEffect(refresh, []);

  async function submit(e) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    try {
      await recruitingApi.createRequisition({
        title: fd.get('title'),
        headcount: Number(fd.get('headcount')) || 1,
        employmentType: fd.get('employmentType') || null,
        location: fd.get('location') || null,
        justification: fd.get('justification') || null,
      });
      form.reset();
      setShowForm(false);
      refresh();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to create');
    }
  }

  return (
    <section data-testid="recruiting-requisitions-page" data-loading={loading ? 'true' : 'false'}>
      <header className="page-header">
        <div>
          <h1>Job Requisitions</h1>
          <p className="muted">{items.length} requisitions</p>
        </div>
        <button className="btn primary" data-testid="recruiting-requisition-create" onClick={() => setShowForm((s) => !s)}>
          {showForm ? 'Close' : '+ New Requisition'}
        </button>
      </header>

      {error && <div className="alert error">{error}</div>}

      {showForm && (
        <form onSubmit={submit} className="card form-card grid-form">
          <label>Title<input name="title" data-testid="recruiting-requisition-title-input" required /></label>
          <label>Headcount<input name="headcount" type="number" min="1" defaultValue="1" /></label>
          <label>Employment Type
            <select name="employmentType" defaultValue="full_time">
              <option value="full_time">Full-time</option>
              <option value="part_time">Part-time</option>
              <option value="contract">Contract</option>
              <option value="intern">Intern</option>
            </select>
          </label>
          <label>Location<input name="location" /></label>
          <label className="full">Justification<textarea name="justification" rows={2} /></label>
          <div className="full actions"><button className="btn primary" type="submit" data-testid="recruiting-requisition-submit">Create</button></div>
        </form>
      )}

      <div className="card">
        <table className="data-table" data-testid="recruiting-requisition-list">
          <thead>
            <tr><th>Title</th><th>Department</th><th>Hiring Manager</th><th>Headcount</th><th>Status</th></tr>
          </thead>
          <tbody>
            {items.map((r) => (
              <tr key={r.id} data-testid={`recruiting-requisition-row-${r.id}`}>
                <td><Link to={`/recruiting/requisitions/${r.id}`}>{r.title}</Link></td>
                <td>{r.department_name || '—'}</td>
                <td>{r.hiring_manager_name || '—'}</td>
                <td>{r.headcount}</td>
                <td><span className={`chip status-${r.status}`} data-testid={`recruiting-requisition-status-${r.id}`}>{r.status}</span></td>
              </tr>
            ))}
            {!loading && items.length === 0 && <tr><td colSpan={5} className="muted">No requisitions yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </section>
  );
}
